<template>
  <div class="works-page">
    <header class="works-head">
      <div class="sec-inner">
        <div class="sec-eyebrow">产品与项目</div>
        <h1 class="works-title">给客户做的，和自己写的</h1>
        <p class="works-intro">{{ profile.intro }}</p>
      </div>
    </header>

    <!-- 行业方案 -->
    <section class="sec">
      <div class="sec-inner">
        <div class="sec-head">
          <div class="sec-eyebrow">行业方案</div>
          <h2 class="sec-title">医疗与医保信息化</h2>
          <p class="sec-sub">
            {{ company.name }} 的核心产品线，以下三个方案提供在线演示。
          </p>
        </div>

        <div class="sol-grid">
          <a
            class="sol-card"
            v-for="s in solutions"
            :key="s.name"
            :href="s.demo"
            target="_blank"
            rel="noopener"
          >
            <div class="sol-tagline">{{ s.tagline }}</div>
            <h3 class="sol-name">{{ s.name }}</h3>
            <p class="sol-desc">{{ s.desc }}</p>
            <div class="sol-tags">
              <span v-for="t in s.tags" :key="t">{{ t }}</span>
            </div>
            <div class="sol-foot">在线演示 &rarr;</div>
          </a>
        </div>

        <div class="others">
          <div class="others-head">同一条线上的其他平台</div>
          <div class="others-list">
            <div class="other" v-for="o in otherPlatforms" :key="o.name">
              <div class="other-name">{{ o.name }}</div>
              <div class="other-desc">{{ o.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 自己的产品 -->
    <section class="sec sec-alt">
      <div class="sec-inner">
        <div class="sec-head">
          <div class="sec-eyebrow">自研</div>
          <h2 class="sec-title">自研产品</h2>
          <p class="sec-sub">工作之余独立开发的产品，从设计、开发到运营都由自己完成。</p>
        </div>
        <v-row>
          <v-col
            v-for="p in products"
            :key="p.name"
            cols="12"
            sm="6"
            lg="6"
            class="work-col"
          >
            <ProductCard :product="p" />
          </v-col>
        </v-row>
      </div>
    </section>

    <!-- 合作 -->
    <section class="sec">
      <div class="sec-inner">
        <div class="sec-head">
          <div class="sec-eyebrow">合作</div>
          <h2 class="sec-title">合作与咨询</h2>
        </div>
        <p class="biz-note">
          医疗机构、医保部门与行业伙伴，如需了解产品细节或洽谈合作，欢迎直接来电：
          <a :href="'tel:' + profile.phone" class="phone">{{ profile.phone }}</a>
          （微信同号），也可以发邮件到
          <a :href="'mailto:' + profile.email">{{ profile.email }}</a>。
          更多信息见 <router-link to="/about">关于</router-link> 和
          <a :href="company.site" target="_blank" rel="noopener">公司官网</a>。
        </p>
        <WechatCopy />
      </div>
    </section>
  </div>
</template>

<script>
import ProductCard from "@/components/ProductCard";
import WechatCopy from "@/components/WechatCopy";
import {
  products,
  solutions,
  otherPlatforms,
  company,
  profile
} from "@/assets/js/profile";

export default {
  name: "Works",
  components: { ProductCard, WechatCopy },
  data() {
    return { products, solutions, otherPlatforms, company, profile };
  },
  metaInfo: {
    title: "产品与项目 - 穆雄雄",
    meta: [
      {
        name: "keywords",
        content:
          "区域慢病管理平台,数智长护监管,智慧电梯追溯,医保监管,互联网医院,小鱼早晚安,雄雄的工具箱,穆雄雄产品"
      },
      {
        name: "description",
        content:
          "穆雄雄做过的产品与项目：区域慢病管理平台、数智长护整体监管、智慧电梯追溯维保三个可在线演示的行业方案，以及小鱼早晚安、雄雄的工具箱等自研小程序和开源项目。"
      }
    ]
  }
};
</script>

<style scoped>
.works-page {
  background: var(--bg);
}
.works-head {
  padding: 120px 24px 56px;
  border-bottom: 1px solid var(--border-soft);
}
.works-title {
  font-size: 44px;
  line-height: 1.25;
  font-weight: 600;
  letter-spacing: -1px;
  color: var(--ink);
  margin: 0 0 22px;
}
.works-intro {
  font-size: 15.5px;
  line-height: 2;
  color: var(--ink-soft);
  max-width: 680px;
  margin: 0;
}
.sec-head {
  margin-bottom: 40px;
}
.work-col {
  display: flex;
}

/* 方案卡片 */
.sol-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 22px;
}
.sol-card {
  display: flex;
  flex-direction: column;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 30px 28px 24px;
  transition: border-color 0.2s ease, transform 0.2s ease;
}
.sol-card:hover {
  border-color: var(--accent);
  transform: translateY(-2px);
}
.sol-tagline {
  font-size: 12.5px;
  letter-spacing: 1px;
  color: var(--accent);
  margin-bottom: 10px;
}
.sol-name {
  font-size: 21px;
  font-weight: 600;
  color: var(--ink);
  margin: 0 0 16px;
  letter-spacing: -0.3px;
}
.sol-desc {
  font-size: 14.5px;
  line-height: 1.95;
  color: var(--ink-soft);
  margin: 0 0 18px;
  flex: 1 1 auto;
}
.sol-tags {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.sol-tags span {
  font-size: 12.5px;
  color: var(--ink-mid);
  background: var(--bg-alt);
  border-radius: 6px;
  padding: 4px 10px;
  margin: 0 7px 7px 0;
}
.sol-foot {
  padding-top: 16px;
  border-top: 1px solid var(--border-soft);
  font-size: 14px;
  font-weight: 500;
  color: var(--accent);
}

/* 其他平台 */
.others {
  margin-top: 52px;
}
.others-head {
  font-size: 13px;
  letter-spacing: 1.5px;
  color: var(--ink-faint);
  margin-bottom: 18px;
}
.others-list {
  display: grid;
  /* 四项，排成 2x2 才齐；260px 会挤成 3 列导致最后一行落单 */
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 0 34px;
  border-top: 1px solid var(--border);
}
.other {
  padding: 20px 0;
  border-bottom: 1px solid var(--border-soft);
}
.other-name {
  font-size: 15.5px;
  font-weight: 500;
  color: var(--ink);
  margin-bottom: 6px;
}
.other-desc {
  font-size: 13.5px;
  line-height: 1.85;
  color: var(--ink-soft);
}

.biz-note {
  font-size: 15.5px;
  line-height: 2.1;
  color: var(--ink-soft);
  margin: 0;
  max-width: 720px;
}
.phone {
  font-weight: 600;
  letter-spacing: 0.4px;
}

@media (max-width: 760px) {
  .works-head {
    padding: 96px 20px 40px;
  }
  .works-title {
    font-size: 30px;
  }
}
</style>
